<template>
    <div class="record-box">
        <div class="info-part">
            <div class="part-text">
                <span>{{obj.QuotationRef}}</span>
            </div>

            <div class="part-text">
                <span>{{obj.OrderDate}}</span>
            </div>

            <div class="part-text">
                <span>{{obj.TotalSum}} {{obj.CurrInOrder}}</span>
            </div>

        </div>

        <div class="operation-part">
            <el-text type="primary" @click="clickPrintBtn" tkey="列印">{{i18n.tkey("lang_print")}}</el-text>
        </div>
    </div>
</template>

<script setup>

    import {inject} from "vue";

    const props = defineProps(["obj"])
    const emits = defineEmits(["clickPrint"])

    const i18n = inject("i18n")

    function clickPrintBtn() {
        emits("clickPrint", props.obj.QuotationRef, props.obj.CompanyCode)
    }

</script>

<style scoped>
    .record-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        padding: 10px;
        box-sizing: border-box;
        border: 1px #E4E7ED solid;
    }

    .record-box .info-part {
        display: flex;
        align-items: center;
        width: calc(100% - 50px);
    }

    .record-box .info-part .part-text {
        width: 33%;
        text-align: left;
    }

    .record-box .operation-part {
        width: 50px;
    }
</style>